import React from "react"
import '../App.css';
import NavBar from "./NavBar";
import Main from "./Main";

function App() {
  return (
    <div className="App">
      <link href='https://fonts.googleapis.com/css?family=Righteous' rel='stylesheet'></link>
      <link rel="stylesheet" href="https://use.typekit.net/yaq6azp.css"></link>
      <NavBar />
      <Main />
    </div>
  );
}

export default App;